import moment from "moment";
import { capitalizeFirstLetter } from "../";

export const formatDateDayMonthTime = (date: Date) => {
  const formattedDate = moment(date).format("DD MMM HH:mm");
  const [day, month, time] = formattedDate.split(" ");
  const capitalizedMonth = capitalizeFirstLetter(month);
  return `${day} ${capitalizedMonth} ${time}`;
};
